import { makeCurrentUserQueryKeyPrefix } from 'features/currentUser/currentUserQueries';
import { dataScienceClient } from 'services/backofficeIntegration/http/client/createDataScienceClient';
import { queryEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';
import { createUuidV4 } from 'utils/createUuidV4';

export type ClaimReference = {
  id: string;
  title: string;
  created: string;
  source: string;
  favicon?: string;
  credibility: 'low' | 'mixed' | 'medium' | 'high' | 'unknown';
  content: string;
  // Badly named judgment/rating of this reference
  label: 'pro' | 'con' | 'neutral';
};

export const httpSearchReferencesByClaim = queryEndpoint({
  makeQueryKey: () => {
    return [
      ...makeCurrentUserQueryKeyPrefix(),
      'fact-grabbing',
      'search-references-by-claim'
    ] as const;
  },
  callEndpoint: (claimText: string) =>
    dataScienceClient
      .post<ClaimReference[]>('/ds-fact-grabbing/search', {
        text: claimText
      })
      .then(response =>
        response.data.map(reference => ({
          // @ts-expect-error The entry doesn't contain an id
          id: createUuidV4(),
          ...reference
        }))
      )
});
